import { render, staticRenderFns } from "./TabPriceVariation.vue?vue&type=template&id=6141efce&scoped=true"
import script from "./TabPriceVariation.vue?vue&type=script&lang=js"
export * from "./TabPriceVariation.vue?vue&type=script&lang=js"
import style0 from "./TabPriceVariation.vue?vue&type=style&index=0&id=6141efce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141efce",
  null
  
)

export default component.exports